import memoizeWith from 'ramda/src/memoizeWith'

export default memoizeWith(
	(state, { moduleId }) => moduleId,
	(state, { moduleId }) => ['embedded', moduleId, 'fieldData'],
)
